<template>
  <div class="inputs-radio-group">
    <slot />
  </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  modelValue: {
    type: [String, Number, Boolean],
    default: null
  },
  name: {
    type: String,
    default: 'radio-group'
  }
})
const emits = defineEmits(['update:modelValue', 'change'])

const modelValueRef = ref(props.modelValue)

watch(() => props.modelValue, (newValue) => {
  modelValueRef.value = newValue
})

// Provide the state to child components
provide('radioGroupName', props.name)
provide('radioGroupModelValue', modelValueRef)
provide('updateRadioValue', (value: any) => {
  modelValueRef.value = value
  emits('update:modelValue', value)
  emits('change', value)
})
</script>

<style lang="scss">
.inputs-radio-group {
  display: flex;
  flex-direction: column;
  gap: .5rem;
}
</style>
